export function calculateWordWidth(word: string, fontSize: number) {
  const span = document.createElement('span');
  span.textContent = word;
  span.style.fontSize = `${fontSize}px`;
  document.body.appendChild(span);
  const width = span.offsetWidth;
  document.body.removeChild(span);
  return width;
}
